import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import '../../Assets/CSS/Enquiries.css';
import { useParams } from 'react-router-dom';
import { Toast } from 'bootstrap';
import { getCookie } from '../../components/auth/login/GetCookie';

const DetailEnquiry = ({ setActiveTab, enquiry }) => {
  const [loading, setLoading] = useState(false);
  const [initialMessage, setInitialMessage] = useState("");
  const [replies, setReplies] = useState([]);
  const [productsReview, setProductsReview] = useState([]); // Store all replies
  const bottomRef = useRef(null);
  const [detailenquiry, setDetailEnquiry] = useState({});
  const [writeReview, setWriteReview] = useState([]);
  const { id } = useParams();
  console.log("enquiry", enquiry);

  useEffect(() => {
    fetchDetailEnquiry();
    fetchProductsReview();
  }, [replies]);

  // useEffect(() => {
  //   bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  // }, [productsReview]);

  // fetchDetailEnquiry
  const fetchDetailEnquiry = async () => {
    // const token = localStorage.getItem('token');
    setLoading(true);
    const token = getCookie("token");
    if (!token) return console.error('Token not found');

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/product-enquiries/${enquiry}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      setDetailEnquiry(data);
      setInitialMessage(data.productEnquiryMsg); // Store the initial enquiry message
    } catch (error) {
      console.error('Error fetching enquiry details:', error);
    }
    finally {
      setLoading(false);
    }
  };
  // fetch product review
  const fetchProductsReview = async () => {
    // const token = localStorage.getItem('token');
    setLoading(true);
    const token = getCookie("token");
    if (!token) return console.error('Token not found');

    try {
      // Fetch all replies from the correct endpoint
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/product-enquiries/replies/${enquiry}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      // Sort replies by date to maintain chronological order
      const filteredData = data.map(({ repliedByName, productEnquiryReplyMsg, repliedById, repliedAt }) => ({
        repliedByName,
        productEnquiryReplyMsg,
        repliedById,
        repliedAt
      }));
      setProductsReview(filteredData);
    } catch (error) {
      console.error('Error fetching reviews:', error);
    }
    finally {
      setLoading(false);
    }
  };

  // write a reply to enquiry
  // const handleWriteReview = async () => {
  //   const token = localStorage.getItem('token');
  //   if (!token) return console.error('Token not found');
  //   if (!writeReview.trim()) return alert('Reply cannot be empty');

  //   const payload = {
  //     productEnquiryId: parseInt(id, 10),
  //     productEnquiryReplyMsg: writeReview,
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/v1/product-enquiries/replies/${id}`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`
  //       },
  //       body: JSON.stringify(payload)
  //     });

  //     if (!response.ok) throw new Error(`Server error: ${response.status} ${response.statusText}`);

  //     // Directly update state to display the new reply instantly
  //     const newReply = await response.json();
  //     setReplies(prevReplies => [...prevReplies, newReply]);
  //     setWriteReview(""); // Clear input field
  //   } catch (error) {
  //     console.error('Error submitting review:', error);
  //   }
  // };
  const handleWriteReview = async () => {
    // const token = localStorage.getItem('token');
    setLoading(true);
    const token = getCookie("token");
    if (!token) return console.error('Token not found');
    if (!writeReview.trim()) return alert('Reply cannot be empty');

    const payload = {
      productEnquiryReplyMsg: writeReview,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/product-enquiries/replies/${enquiry}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error(`Server error: ${response.status} ${response.statusText}`);

      // Directly update state to display the new reply instantly
      const newReply = await response.json();
      setReplies(prevReplies => [...prevReplies, newReply]);
      setWriteReview(""); // Clear input field
    } catch (error) {
      console.error('Error submitting review:', error);
    }
    finally {
      setLoading(false);
    }
  };


  return (
    <div className="container mb-5">
      <div className='row'>
        <div className='col-md-12'>
          <div className="d-flex align-items-center mt-2 py-2 px-2"
            style={{ backgroundColor: '#FFF8E4', border: '1px solid #FFF8E4' }}>
            <Icon
              icon="ep:back"
              className="fs-3 dash-link me-3"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setActiveTab("enquiries")
              }}
            />
            {/* <span className='enquiry-id me-3 '>
              <h6>{detailenquiry.productEnquiryId}</h6>
            </span> */}

            <h5 className='enquiry-title'>{detailenquiry.productName}</h5>
          </div>
        </div>
      </div>
      {/* enquiry details */}
      <div className='row mt-3'>
        <div className='col-md-12'>
          <div className="table-responsive no-border deatil-enquiry-table ">
            <table className="table no-border">
              <thead>
                <tr>
                  <th className='enquiry-fields'>Fields</th>
                  <th className='enquiry-fields'>Content</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='enquiry-fields'>Enquiry ID</td>
                  <td className='enquiry-value'>{detailenquiry.productEnquiryId}</td>
                </tr>
                <tr>
                  <td className='enquiry-fields'>Buyer Name</td>
                  <td className='enquiry-value'>{detailenquiry.buyerName}</td>
                </tr>
                {/* <tr>
                  <td className='enquiry-fields'>Contact Details</td>
                  <td className='enquiry-value'>{detailenquiry.sellerEmailId}</td>
                </tr>
                <tr>
                  <td className='enquiry-fields'>Company Name</td>
                  <td className='enquiry-value'>{detailenquiry.sellerName}</td>
                </tr> */}
                <tr>
                  <td className='enquiry-fields'>Product Name</td>
                  <td className='enquiry-value'>{detailenquiry.productName}</td>
                </tr>
                <tr>
                  <td className='enquiry-fields'>Enquiry Date</td>
                  <td className='enquiry-value'>
                    {new Date(detailenquiry.enquiryCreatedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* product image */}
      {/* <div>
        <div className='col-md-10 border mt-3 mb-4 rounded'>
          <h6 className='product-image-title px-2 py-2'>Product image</h6>
          <img src={'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2FyfGVufDB8fDB8fHww&w=1000&q=80'}
            alt="Product"
            className='product-image image-rectangle p-2 my-2 mx-4 ' />
        </div>
      </div> */}

      {/* Display Initial Message */}
      <div className='row mt-3'>
        <div className='col-md-10'>
          <div className="message-box right">
            <p>{initialMessage}</p>
          </div>
        </div>
      </div>

      {/* Display Replies */}
      <div className='row mt-3'>
        <div className='col-md-10'>
          {productsReview.map((reply, index) => {
            const isBuyer = detailenquiry.buyerId !== reply.repliedById;
            return (
              <div
                key={index}
                className={`message-box ${isBuyer ? "left" : "right"}`} // Conditionally set class
                style={{
                  textAlign: "left",
                  backgroundColor: isBuyer ? "#f1f1f1" : "#d1e7ff",
                  padding: "10px",
                  borderRadius: "10px",
                  margin: "5px 0",
                  maxWidth: "75%"
                }}
              >
                <p> {reply.productEnquiryReplyMsg}</p>
                <small style={{ fontSize: '11px', color: '#aaa', float: isBuyer ? 'left' : 'right' }}>
                  {new Date(reply.repliedAt).toLocaleString()}
                </small>
              </div>
            );
          })}
          <div ref={bottomRef} />
        </div>
      </div>

      {/* Input for Writing a Reply */}
      <div className='col-md-10 mt-3 d-flex align-items-center px-1'
        style={{
          border: '1px solid #FDC400',
          borderRadius: '10px'
        }}>
        <input type="text" className="form-control py-2 my-1 border-0 outline-0"
          value={writeReview}
          onChange={(e) => setWriteReview(e.target.value)}
          placeholder="Write Reply..."
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleWriteReview();
            }
          }} />
        <button className="btn ms-2 my-1 px-4 py-1 d-flex align-items-center gap-2"
          style={{
            backgroundColor: '#FDC400',
            color: '#fff',
            borderRadius: '10px'
          }}

          onClick={handleWriteReview}
        >
          {/* <Icon icon="grommet-icons:send" />
          Send */}
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Sending...
            </>
          ) : (
            <>
              <Icon icon="grommet-icons:send" />
              Send
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default DetailEnquiry;